import { createAction, props } from '@ngrx/store';
import { ExpirationDateConfiguration } from '../../api/models/expiration-date-configuration.model';
import { MetadataConfigurationDto } from '../../api/models/metadata-configuration-dto.model';
import { AcceptanceIdentifierDto } from '../../api/models/acceptance-identifier-dto.model';

export const getMetadataConfiguration = createAction(
    '[Metadata Configuration] Get Metadata Configuration',
    props<{
        documentTypeId: number;
    }>()
);

export const getMetadataConfigurationSuccess = createAction(
    '[Metadata Configuration] Get Metadata Configuration Success',
    props<{ metadataConfiguration: MetadataConfigurationDto }>()
);

export const getMetadataConfigurationFailure = createAction(
    '[Metadata Configuration] Get Metadata Configuration Failure',
    props<{ error: unknown }>()
);

export const addAcceptanceIdentifier = createAction(
    '[Metadata Configuration] Add Acceptance Identifier',
    props<{ acceptanceIdentifier: AcceptanceIdentifierDto }>()
);

export const updateAcceptanceIdentifier = createAction(
    '[Metadata Configuration] Update Acceptance Identifier',
    props<{ acceptanceIdentifier: AcceptanceIdentifierDto }>()
);

export const sortAcceptanceIdentifiers = createAction(
    '[Metadata Configuration] Sort Acceptance Identifiers',
    props<{ acceptanceIdentifiers: AcceptanceIdentifierDto[] }>()
);

export const updateExpirationDateConfiguration = createAction(
    '[Metadata Configuration] Update Expiration Date Configuration',
    props<{
        acceptanceIdentifier: AcceptanceIdentifierDto;
        expirationDateConfiguration: ExpirationDateConfiguration;
    }>()
);

export const resetMetadataConfiguration = createAction('[Metadata Configuration] Reset Metadata Configuration');
